import { createFileRoute } from "@tanstack/react-router"
import { CompanySettingsPage } from "@/features/companies/company-settings-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/settings")({
    component: CompanySettingsPage,
})
